/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-03-03T10:29:11.554
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentPublishChannel,
	listRentPublishChannelInit,
	listRentPublishChannelByAuthorizations,
	deleteRentPublishChannel
	
} from '@api/rentmanage/RentPublishChannel';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentPublishChannel({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentPublishChannel(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentPublishChannelByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentPublishChannelByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentPublishChannelInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentPublishChannelInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentPublishChannel({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentPublishChannel({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
